import { createComponent, ElementWithProps } from '@carvana/merch-components';
import cx from 'classnames';

export const HeroWrapper = createComponent('div', {
  className: 'relative grid'
});

export const HeroImageContainer = createComponent('div', {
  className:
    'col-span-full row-span-full h-[264px] w-full overflow-hidden bg-background-primary sm:h-[307px] md:h-[364px]'
});

export const HeroImage = createComponent('div', {
  className: 'h-full w-full md:ml-[50%]'
});

export const HeroContentContainer = createComponent<
  ElementWithProps<{ isLoggedIn: boolean }>
>('div', ({ isLoggedIn }) => ({
  className: cx(
    'col-span-full row-span-full flex px-2xl pb-7xl pt-2xl sm:justify-center sm:pt-4xl sm:px-3xl sm:pb-8xl md:py-4xl md:pb-[144px]',
    {
      'md:pb-[118px]': isLoggedIn
    }
  )
}));

export const WelcomeBackWrapper = createComponent('div', {
  className:
    'flex h-full w-full max-w-[1272px] flex-col justify-between md:justify-end sm:gap-5xl md:gap-2xl'
});

export const WelcomeBack = createComponent('h2', {
  className: 'text-text-inverse t-brand-sm sm:t-brand-md md:t-brand-lg'
});
